import { z } from 'zod';

export const commissionLiabilityStatusEnum = z.enum(['WAITING_FOR_INVOICE', 'UNPAID', 'PAID']);
export const commissionLiabilityStatusFilterEnum = z.enum([...commissionLiabilityStatusEnum.options, 'OVERDUE']);
export type TCommissionLiabilityStatusFilter = z.infer<typeof commissionLiabilityStatusFilterEnum>;
export type TCommissionLiabilityStatus = z.infer<typeof commissionLiabilityStatusEnum>;
